import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { HomecardLabel, Checked } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import './HomeCardLabels.scss';
import Superlister from '../icons/Superlister';

const HomeCardLabels = ({ checked, isSuperlister }) => (
  <Fragment>
    {checked && (
      <HomecardLabel
        renderIcon={() => <Checked />}
        renderContent={() => trans('homecard.label.checked')}
        className="label--checked"
      />
    )}
    {isSuperlister && (
      <HomecardLabel
        renderIcon={() => <Superlister />}
        renderContent={() => trans('homecard.label.top_lister')}
        className="label--super-lister"
      />
    )}
  </Fragment>
);

HomeCardLabels.propTypes = {
  checked: PropTypes.bool.isRequired,
  isSuperlister: PropTypes.bool.isRequired
};

export const generateHomeCardLabels = ({ checked, isSuperlister }) => () => (
  <HomeCardLabels checked={checked} isSuperlister={isSuperlister} />
);

export default generateHomeCardLabels;
